import dayjs from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import { DATE_FORMAT } from "@lib/constants/system";

dayjs.extend(dayOfYear);

const today = dayjs().startOf("day").format(DATE_FORMAT);
const weekAgo = dayjs().subtract(1, "week").startOf("day").format(DATE_FORMAT);
const monthAgo = dayjs().subtract(1, "month").startOf("day").format(DATE_FORMAT);
const halfYearAgo = dayjs().subtract(6, "month").startOf("day").format(DATE_FORMAT);
const yearAgo = dayjs().subtract(1, "year").startOf("day").format(DATE_FORMAT);
const twoYearsAgo = dayjs().subtract(2, "year").startOf("day").format(DATE_FORMAT);
const ytdAgo = dayjs().startOf("year").format(DATE_FORMAT);

export enum PERIOD {
    WEEK = "WEEK",
    MONTH = "MONTH",
    HALF_YEAR = "HALF_YEAR",
    YEAR = "YEAR",
    YTD = "YTD",
    TWO_YEARS = "TWO_YEARS",
    ALL_TIME = "ALL_TIME",
}

export const DEFAULT_PERIOD = PERIOD.HALF_YEAR;

export type TPeriod = (typeof PERIOD)[keyof typeof PERIOD];
export type TDisplayPeriod =
    | PERIOD.WEEK
    | PERIOD.MONTH
    | PERIOD.HALF_YEAR
    | PERIOD.YTD
    | PERIOD.YEAR
    | PERIOD.TWO_YEARS;

export const DAYS_MAP: Record<TDisplayPeriod, number | (() => number)> = {
    [PERIOD.WEEK]: 7,
    [PERIOD.MONTH]: 30,
    [PERIOD.HALF_YEAR]: 180,
    [PERIOD.YEAR]: 365,
    [PERIOD.YTD]: () => Math.max(dayjs().dayOfYear() - 1, 1),
    [PERIOD.TWO_YEARS]: 2 * 365,
    // [PERIOD.ALL_TIME]: 365 * 2, // 2 years is maximum.
};

export const PERIODS_MAP: Record<TDisplayPeriod, [string, string]> = {
    [PERIOD.WEEK]: [weekAgo, today],
    [PERIOD.MONTH]: [monthAgo, today],
    [PERIOD.HALF_YEAR]: [halfYearAgo, today],
    [PERIOD.YEAR]: [yearAgo, today],
    [PERIOD.YTD]: [ytdAgo, today],
    [PERIOD.TWO_YEARS]: [twoYearsAgo, today],
};
